import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function useMenu() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/menu").then((res) => setItems(res.data)).catch(() => {});
  }, []);
  return items;
}
